import { MSBaseUrl, MSEndpoint, MSUrl } from 'src/app/adapters/http/utils/http.utils';

export function getBingMapsUrl(base: MSBaseUrl, endpoint: MSEndpoint): MSUrl {
  return `${base}/REST/v1/${endpoint}`;
}
